import { render, staticRenderFns } from "./BirthdayPicker.vue?vue&type=template&id=ae002ac0&"
import script from "./BirthdayPicker.vue?vue&type=script&lang=js&"
export * from "./BirthdayPicker.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayPicker.vue?vue&type=style&index=0&id=ae002ac0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports